.shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/*
 * The header was a bare inline-styled flex row: no ground, no rule, and the
 * nav rendered as default browser hyperlinks (`#0000EE`, underlined) in a
 * console whose entire palette is teal. `DES-001`.
 */
.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 1.5rem;
  padding: 0.75rem var(--space-4, 1rem);
  background: var(--card);
  border-bottom: 1px solid var(--line);
}

.mark {
  font-family: var(--font-display);
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--teal-600);
  margin: 0;
}

.nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
  margin-inline-end: auto;
}

.navLink {
  font-family: var(--font-body);
  font-size: var(--text-min-body);
  color: var(--ink-soft);
  text-decoration: none;
  padding: 0.375rem 0.625rem;
  border-radius: var(--radius-sharp);
  border: 1px solid transparent;
  white-space: nowrap;
}

.navLink:hover {
  color: var(--ink);
  background: color-mix(in srgb, var(--teal-500) 8%, transparent);
}

.navLink:focus-visible {
  outline: 2px solid var(--cy-500);
  outline-offset: 1px;
}

/* The current surface was indistinguishable from the other two. */
.navLinkCurrent {
  color: var(--teal-800);
  font-weight: 600;
  background: color-mix(in srgb, var(--teal-500) 12%, transparent);
  border-color: color-mix(in srgb, var(--teal-500) 30%, transparent);
}

.identity {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  font-size: var(--text-min-body);
  color: var(--ink);
  white-space: nowrap;
}

/*
 * The role is on the wire (`tenantAuthMeSchema`'s `user.role`) and was never
 * rendered — on a surface where `R-091` makes the role someone else's choice
 * and three of the four screens are admin-only, "which of the three am I"
 * is the first thing that explains a refusal.
 */
.role {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.content {
  flex: 1 1 auto;
}

/* The pre-session states: a bare sentence flush against the viewport corner. */
.gate {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: var(--space-4, 1rem);
  text-align: center;
}

.gateText {
  color: var(--muted);
  font-size: var(--text-min-body);
  margin: 0;
}
